export default "__VITE_ASSET__BwsJ2JMl__"